import { Component } from 'react';
import { connect } from 'react-redux';
import { loadUsersConfiguration, unloadUsers } from 'binder/actions/usersConfiguration';
import UserPermissionsEditor from 'binder/components/UserPermissionsEditor/UserPermissionsEditor';
import { binderInstitutionIdSelector } from 'common/selectors';
import lodash from 'lodash';

import { LoadingStatus } from 'components/common/LoadingStatus/LoadingStatus';

export class UsersConfiguration extends Component {
    loadUserConfigurationInformation(institutionId) {
        const { binderId } = this.props;
        
        return institutionId && this.props.loadUsersConfiguration(binderId);
    }

    //for the purpose of preventing page from hanging when refreshing internal users page
    componentDidUpdate(prevProps) {
        const currentInstitutionId = prevProps.institutionId;
        const nextInstitutionId = this.props.institutionId;

        if (lodash.isNil(currentInstitutionId) && !lodash.isNil(nextInstitutionId)) {
            this.loadUserConfigurationInformation(nextInstitutionId);
        }
    }

    componentDidMount() {
        this.loadUserConfigurationInformation(this.props.institutionId);
    }

    componentWillUnmount() {
        const { unloadUsers } = this.props;
        if (unloadUsers) unloadUsers();
    }

    render() {
        const { binderId, users, groups, permissionProperties, sortedUsers } = this.props;
        if (lodash.isNil(users) || !permissionProperties) {
            return <LoadingStatus itemName='Users' loading={true} filterQuery={false}/>;
        }
        const editorProps = { binderId, users, groups, permissionProperties, sortedUsers };
        return <UserPermissionsEditor {...editorProps} />;
    }
}

export default connect(
    (state, props) => {
        const filteredPermissionProperties = lodash.isNil(state.permissionProperties)
            ? null
            : lodash.pickBy(state.permissionProperties,
                property => property.permissionPropertyType === 'binder');
        const institutionId = binderInstitutionIdSelector(state);
        const sortedUsers = lodash.map(lodash.orderBy(state.users,
            ['lastName', 'asc'],
            ['firstName', 'asc'],
            ['displayName', 'asc'],
        ), 'sub');

        return {
            binderId: props.params.id,
            users: state.users,
            institutionId,
            sortedUsers: sortedUsers,
            groups: state.groups,
            permissionProperties: filteredPermissionProperties,
        };
    },
    {
        loadUsersConfiguration,
        unloadUsers,
    },
)(UsersConfiguration);
